import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AdminService } from '../../services/admin';
import { Permission } from '../../../../shared/models/permission';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { PermissionForm } from '../permission-form/permission-form';
import { PermissionFormData } from '../../../../shared/models/permission-form-data';
import { Observable } from 'rxjs';
import { PermissionService } from '../../../../core/authorization/permission';

@Component({
	selector: 'app-permissions',
	standalone: true,
	imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule, MatSortModule, MatPaginatorModule],
	templateUrl: './permissions.html',
	styleUrl: './permissions.css'
})

export class Permissions implements OnInit, AfterViewInit {
	dataSource       : MatTableDataSource<Permission> = new MatTableDataSource<Permission>([]);
	displayedColumns : string[]     = ['id', 'name', 'group', 'active', 'createdAt', 'actions'];
	canCreatePermission$ : Observable<boolean>;
	canEditPermission$   : Observable<boolean>;
	canDeletePermission$ : Observable<boolean>;

	@ViewChild(MatSort) sort!: MatSort;
	@ViewChild(MatPaginator) paginator!: MatPaginator;

	constructor(private adminService: AdminService, private dialog: MatDialog, private permissionService: PermissionService) {
		this.canCreatePermission$ = this.permissionService.hasPermission('permissions.create');
        this.canEditPermission$   = this.permissionService.hasPermission('permissions.update');
        this.canDeletePermission$ = this.permissionService.hasPermission('permissions.delete');
	}

	ngOnInit(): void {
		this.loadPermissions();
	}

	ngAfterViewInit(): void {
		this.dataSource.sort      = this.sort;
		this.dataSource.paginator = this.paginator;
	}

	async loadPermissions(): Promise<void> {
		const result = await this.adminService.getAllPermissions();

		if(result) {
			this.dataSource.data = result;
		}
	}

	async onCreatePermission(): Promise<void> {
		const dialogRef = this.dialog.open(PermissionForm, {
			width: '600px',
			disableClose: true,
			data: null
		});

		dialogRef.afterClosed().subscribe(async (result: PermissionFormData | undefined) => {
			if(result) {
				const success = await this.adminService.createPermission({
					id          : result.id,
					name        : result.name,
					description : result.description,
					group       : result.group,
					active      : result.active
				});

				if(success) {
					this.loadPermissions();
				}
			}
		});
	}

	async onEditPermission(permission: Permission): Promise<void> {
		const formData: PermissionFormData = {
            id: permission.id,
            name: permission.name,
            description: permission.description,
            group: permission.group,
            active: permission.active
        };

		const dialogRef = this.dialog.open(PermissionForm, {
			width: '600px',
			disableClose: true,
			data: formData
		});

		dialogRef.afterClosed().subscribe(async (result: PermissionFormData | undefined) => {
            if(result) {
                const permissionId = result.id; 

                const updatePayload: Partial<Omit<PermissionFormData, 'id'>> = {
                    name        : result.name,
                    description : result.description,
                    group       : result.group,
                    active      : result.active
                };

                const success = await this.adminService.updatePermission(permissionId, updatePayload);

                if(success) {
                    this.loadPermissions();
                }
            }
        });
	}

	async onDeletePermission(id: string): Promise<void> {
		if(window.confirm('¿Estás seguro de que quieres eliminar este permiso? Esta acción es irreversible.')) {
			const success = await this.adminService.deletePermission(id);

			if(success) {
				this.loadPermissions();
			}
		}
	}
}
